import memoizeOne from "memoize-one"

function getConfiguration() {
  return fetch(process.env.PUBLIC_URL + "/config.json").then(response => response.json())
}

export default memoizeOne(getConfiguration)
